import React from 'react';
import { useSelector } from 'react-redux';
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { dashboardItemsSelector } from '../../redux/dashboard';
import { CircularProgress, Typography } from '@mui/material';

const colors = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', 'red', 'pink'];

const data = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    uv: 3000,
    amt: 2210,
  },
  {
    name: 'Page C',
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

const getPath = (x, y, width, height) => {
  return `M${x},${y + height}C${x + width / 3},${y + height} ${x + width / 2},${
    y + height / 3
  }
  ${x + width / 2}, ${y}
  C${x + width / 2},${y + height / 3} ${x + (2 * width) / 3},${y + height} ${
    x + width
  }, ${y + height}
  Z`;
};

const TriangleBar = (props) => {
  const { fill, x, y, width, height } = props;

  return <path d={getPath(x, y, width, height)} stroke="none" fill={fill} />;
};

export default function Sales() {
  const defaultChartData = useSelector(dashboardItemsSelector);
  const formatted = defaultChartData?.chartData?.sales?.data.map((item) => {
    return {
      ...item,
      date: item?.date?.split?.('-')?.[1] + '-' + item?.date?.split?.('-')?.[2],
    };
  });
  const chartData = formatted;

  const chartData1 = defaultChartData?.chartData?.sales?.data;
  const isLoading = defaultChartData?.chartData?.sales?.isLoading;
  return (
    <>
      <div>
        <Typography
          variant="h3"
          className="mediumFont"
          style={{ marginTop: 20 }}
        >
          {'Sales detail'}
          <span style={{ fontWeight: 'bold' }}>
            {`(${chartData1?.[0]?.date} to ${
              chartData1?.[chartData1?.length - 1]?.date
            })`}
          </span>
        </Typography>
      </div>

      <ResponsiveContainer width={'100%'} height={400}>
        {isLoading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress size={30} />
          </div>
        ) : (
          <BarChart
            data={chartData}
            margin={{
              top: 30,
              right: 30,
              left: 20,
              bottom: 20,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              // angle={-30}
              // textAnchor="end"
              // interval={0} // optional: show all ticks
              tick={{ fontSize: 14 }}
            />
            <YAxis tick={{ fontSize: 14 }} />
            <Tooltip />
            <Bar
              dataKey="total_sales"
              fill="#8884d8"
              name={'Total Sales'}
              shape={<TriangleBar />}
              label={{ position: 'top' }}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index % 20]} />
              ))}
            </Bar>
          </BarChart>
        )}
      </ResponsiveContainer>
    </>
  );
}
